import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

// Event name has to match what appears in the database
export enum RequestAccessTelemetryEvents {
  Displayed = 'RequestAccessDisplayed',
  Clicked = 'RequestAccessClicked'
}

export interface RequestAccessDisplayedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.Displayed;
  contentType: string;
}

export interface RequestAccessClickedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.Clicked;
  contentType: string;
}

export function sendRequestAccessDisplayedTelemetry(contentType: string) {
  Telemetry.sendEvent<RequestAccessDisplayedEvent>({
    type: RequestAccessTelemetryEvents.Displayed,
    contentType
  });
}

export function sendRequestAccessClickedTelemetry(contentType: string) {
  Telemetry.sendEvent<RequestAccessClickedEvent>({
    type: RequestAccessTelemetryEvents.Clicked,
    contentType
  });
}
